import { useMemo } from 'react';
import {
  EMPTY_WALLET_PENDING_BREAKDOWN,
  sumPendingBreakdown,
  type WalletPendingBreakdown,
  type WalletPendingPayoutItem,
} from '@foodfluence/shared';

export interface UseWalletPendingBreakdownOptions {
  /** Pending breakdown from useWalletBootstrap (or equivalent loader). */
  bootstrapBreakdown?: WalletPendingBreakdown;
  bootstrapItems?: WalletPendingPayoutItem[];
  bootstrapLoaded?: boolean;
}

/** Derives pending payout totals from bootstrap — no independent fetch. */
export function useWalletPendingBreakdown({
  bootstrapBreakdown,
  bootstrapItems,
  bootstrapLoaded = false,
}: UseWalletPendingBreakdownOptions) {
  const breakdown = bootstrapBreakdown ?? { ...EMPTY_WALLET_PENDING_BREAKDOWN };
  const items = bootstrapItems ?? [];
  const loading = !bootstrapLoaded;
  const totalPending = useMemo(() => sumPendingBreakdown(breakdown), [breakdown]);

  return { breakdown, items, totalPending, loading, error: null };
}
